import * as React from 'react';
import { IgcListItemComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * The list-item component is a container
 * intended for row items in the list component.
 * @slot  - Renders custom content.
 * @slot start - Renders content before all other content.
 * @slot end - Renders content after all other content.
 * @slot title - Renders the title.
 * @slot subtitle - Renders the subtitle.
 * @csspart start - The start container.
 * @csspart end - The end container.
 * @csspart content - The header and custom content container.
 * @csspart header - The title and subtitle container.
 * @csspart title - The title container.
 * @csspart subtitle - The subtitle container.
 * @class
 */
export const IgrListItem = /* @__PURE__ */ createComponent({
  tagName: 'igc-list-item',
  displayName: 'IgrListItem',
  elementClass: Component,
  react: React,
});

export type IgrListItem = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrListItemModule = Component;
